module.exports = ":host {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%); }\n  :host .logo {\n    margin: 0 auto 60px;\n    width: 120px; }\n  :host .logo picture > * {\n      width: 100%; }\n  :host .form {\n    width: 400px;\n    margin: 0 auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/login/login.component.scss
// module id = ./src/app/views/login/login.component.scss
// module chunks = main